'use client'

import { StreamableValue, useUIState } from 'ai/rsc'
import type { AI } from '@/app/action'
import { CollapsibleMessage } from './collapsible-message'
import ScrollToBottomButton from './ui/scroll-to-bottom-button'
import { useSession } from 'next-auth/react'

export function ChatMessages() {
  const session = useSession()
  const [messages, setMessages] = useUIState<typeof AI>()

  if (messages.length === 0) {
    return null
  }

  return (
    <div className="h-full flex-1 relative">
      <div className="px-8 space-y-3 md:space-y-4 flex flex-col">
        {messages.map(
          (message: {
            id: number
            component: React.ReactNode
            isCollapsed?: StreamableValue<boolean>
          }) => (
            <CollapsibleMessage
              key={message.id}
              message={message}
              isLastMessage={message.id === messages[messages.length - 1].id}
            />
          )
        )}
      </div>
      <ScrollToBottomButton />
    </div>
  )
}
